import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { fetchSingleInvoicePdf } from 'redux/billing/actions';

import Moment from 'react-moment';

import CommonTable from 'components/elements/tables/common-table/CommonTable';

import './BillingInvoicesListItem.css';


const BillingInvoicesListItem = props => {
  const { item, fetchSingleInvoicePdf } = props;
  const { t } = useTranslation();

  return (
    <CommonTable.Row className="billing-invoices-list-item__component">
      <CommonTable.Cell>
        <div className="parameter">{t("Date")}</div>
        <div className="value">
          <Moment
            format="YYYY/MM/DD hh:mm:ss"
            date={item.date}
          />
        </div>
      </CommonTable.Cell>
      <CommonTable.Cell>
        <div className="parameter">{t("Amount")}</div>
        <div className="value">{item.amount_paid}</div>
      </CommonTable.Cell>
      <CommonTable.Cell>
        <div className="parameter">{t("Description")}</div>
        <div className="value">{item.plan}</div>
      </CommonTable.Cell>
      <CommonTable.Cell>
        <div className="parameter">{t("Invoice")}</div>
        <div className="value">
          <div
            className="invoice-number"
            onClick={() => fetchSingleInvoicePdf(item.id) }
            role="button"
            tabIndex={-1}
          >
            <div className="icon" />
            <div className="number">{item.number}</div>
          </div>
        </div>
      </CommonTable.Cell>
    </CommonTable.Row>
  );
};

BillingInvoicesListItem.propTypes = {
  fetchSingleInvoicePdf: PropTypes.func.isRequired,
  item: PropTypes.object,
};

const mapStateToProps = state => (
  {}
);

export default connect(
  mapStateToProps,
  {
    fetchSingleInvoicePdf,
  },
)(BillingInvoicesListItem);
